import Lottie from 'lottie-react';
import { usePrefersReducedMotion } from '@/hooks/use-prefers-reduced-motion';
import { cn } from '@/lib/utils';
import aiSparklesAnimation from '@/pages/assets/animations/ai-sparkles.json';

interface AISparklesAnimationProps {
    className?: string;
    loop?: boolean;
}

export default function AISparklesAnimation({ className, loop = false }: AISparklesAnimationProps) {
    // The repo's `motion-safe:` convention only reaches CSS transitions; a
    // Lottie player loops from JavaScript and would keep going regardless. The
    // looping case is the one that matters — it sits beside a skeleton for the
    // length of a generation.
    const prefersReducedMotion = usePrefersReducedMotion();

    return (
        <Lottie
            animationData={aiSparklesAnimation}
            loop={prefersReducedMotion ? false : loop}
            autoplay={!prefersReducedMotion}
            className={cn('size-full', className)}
        />
    );
}
